import { call, take, takeLeading, takeEvery, race, put } from "redux-saga/effects";
import { actionWatcher } from "services/redux/sagas/common/";
import { liveRefreshFor } from "../common";

import omit from "lodash/omit";

import {
  loadSingleSitesListStart,
  loadSingleSitesListSuccess,
  loadSingleSitesListFailed,
  loadSingleSitesListCancel,
  loadSingleSitesListRefreshStart,
  loadSingleSitesListRefreshSuccess,
  loadSingleSitesListRefreshFailed,
  loadSingleSiteViewStart,
  loadSingleSiteViewSuccess,
  loadSingleSiteViewFailed,
  loadSingleSiteViewCancel,
  loadSingleSiteContactsStart,
  loadSingleSiteContactsSuccess,
  loadSingleSiteContactsFailed,
  loadSingleSiteContactsCancel,
  requestAddSinglesitecontactStart,
  requestAddSinglesitecontactSuccess,
  requestAddSinglesitecontactFailed,
  requestAddSinglesitecontactCancel,
  requestUpdateSinglesitecontactStart,
  requestUpdateSinglesitecontactSuccess,
  requestUpdateSinglesitecontactFailed,
  requestUpdateSinglesitecontactCancel,
  requestRemoveSinglesitecontactStart,
  requestRemoveSinglesitecontactSuccess,
  requestRemoveSinglesitecontactFailed,
  requestRemoveSinglesitecontactCancel,
  requestMoveSinglesitecontactStart,
  requestMoveSinglesitecontactSuccess,
  requestMoveSinglesitecontactFailed,
  requestMoveSinglesitecontactCancel,
  loadSingleSiteNotificationsRulesStart,
  loadSingleSiteNotificationsRulesSuccess,
  loadSingleSiteNotificationsRulesFailed,
  loadSingleSiteNotificationsRulesCancel,
  singleSiteNotificationsAddRuleStart,
  singleSiteNotificationsAddRuleSuccess,
  singleSiteNotificationsAddRuleFailed,
  singleSiteNotificationsAddRuleCancel,
  singleSiteNotificationsRemoveRuleStart,
  singleSiteNotificationsRemoveRuleSuccess,
  singleSiteNotificationsRemoveRuleFailed,
  singleSiteNotificationsRemoveRuleCancel,
  loadSingleSiteNotificationHistoryStart,
  loadSingleSiteNotificationHistorySuccess,
  loadSingleSiteNotificationHistoryFailed,
  loadSingleSiteNotificationHistoryCancel,
  loadSiteSchedulesStart,
  loadSiteSchedulesSuccess,
  loadSiteSchedulesFailed,
  loadSiteSchedulesCancel,
  loadSingleSiteUsersStart,
  loadSingleSiteUsersSuccess,
  loadSingleSiteUsersFailed,
  loadSingleSiteUsersCancel,
  singleSiteUserGrantAccessStart,
  singleSiteUserGrantAccessSuccess,
  singleSiteUserGrantAccessFailed,
  singleSiteUserGrantAccessCancel,
  singleSiteUserRemoveStart,
  singleSiteUserRemoveSuccess,
  singleSiteUserRemoveFailed,
  singleSiteUserRemoveCancel,
} from "services/redux/actions/singleSites";
  
import conxtdOut from "apis/conxtdOut";

// LIST
export function* watchLoadSingleSitesList() {
  yield actionWatcher({
    actions: {
      start: loadSingleSitesListStart,
      failed: loadSingleSitesListFailed,
      success: loadSingleSitesListSuccess,
      cancel: loadSingleSitesListCancel,
    },
    saga: loadSingleSitesListRe,
  });
}

// {{url}}/single-sites/index/:hours
export function* loadSingleSitesListRe(action) {
  try {
    const url = `/single-sites/index/${action.timeframe || "24"}`;

    const result = yield call(conxtdOut.get, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// LIST LIVE REFRESH
export function* watchLoadSingleSitesListRefresh() {
  yield takeEvery("LOAD_SINGLE_SITES_LIST_REFRESH_START", function*(action) {
    yield race({
      task: call(loadSingleSitesListRefreshRe, action),
      cancel: take([
        "LOAD_SINGLE_SITES_LIST_REFRESH_CANCEL",
      ])
    });
  });
}

// {{url}}/single-sites/index/:hours
export function* loadSingleSitesListRefreshRe(action) {
  try {
    const interval = 30 * 1000; // refresh every 30 sec
    
    const params = {
      startAction: loadSingleSitesListRefreshStart,
      startActionParams: {
        ...action,
        interval,
      },
      successAction: loadSingleSitesListRefreshSuccess,
      successActionParams: {
        interval,
      },
      failedAction: loadSingleSitesListRefreshFailed,
      apiCall: call(
        conxtdOut.get,
        `/single-sites/index/${action.timeframe || "24"}`
      ),
      interval,
      key: "data",
      refresh: true,
    };

    const result = yield liveRefreshFor(params);

    return result;
  } catch (e) {
    console.error(e);
  }
}

// CURRENT SITE
export function* watchLoadSingleSiteView() {
  yield actionWatcher({
    actions: {
      start: loadSingleSiteViewStart,
      failed: loadSingleSiteViewFailed,
      success: loadSingleSiteViewSuccess,
      cancel: loadSingleSiteViewCancel,
    },
    saga: loadSingleSiteViewRe,
  });
}

// {{url}}/single-sites/site-view/:sudo_site_id/:hours
export function* loadSingleSiteViewRe(action) {
  const { sudo_site_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for loading single site view"
    );

  try {
    const url = `/single-sites/site-view/${sudo_site_id}/${action.timeframe || "24"}`;

    let result = yield call(conxtdOut.get, url, action.params);

    const siteData = result.data;

    return {
      ...omit(result, ["data"]),
      site: siteData,
    }

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// LOAD SITE CONTACTS/KEYHOLDERS
export function* watchLoadSingleSiteContacts() {
  yield actionWatcher({
    actions: {
      start: loadSingleSiteContactsStart,
      failed: loadSingleSiteContactsFailed,
      success: loadSingleSiteContactsSuccess,
      cancel: loadSingleSiteContactsCancel,
    },
    saga: loadSingleSiteContactsRe,
  });
}

// {{url}}/single-sites/contacts/:sudo_site_id
export function* loadSingleSiteContactsRe(action) {
  const { sudo_site_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for loading contacts"
    );

  try {
    const url = `/single-sites/contacts/${sudo_site_id}`;

    const result = yield call(conxtdOut.get, url, action.params);

    const keyholdersData = result.data;

    return {
      ...omit(result, ["data"]),
      keyholders: keyholdersData,
    }

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// ADD SITE CONTACTS/KEYHOLDERS
export function* watchSingleSiteAddContact() {
  // Reload keyholders on successful add
  yield takeLeading("REQUEST_ADD_SINGLESITECONTACT_SUCCESS", function*(action) {
    yield put(
      loadSingleSiteContactsStart({
        sudo_site_id: action.startAction.sudo_site_id
      })
    );
  });

  yield actionWatcher({
    actions: {
      start: requestAddSinglesitecontactStart,
      failed: requestAddSinglesitecontactFailed,
      success: requestAddSinglesitecontactSuccess,
      cancel: requestAddSinglesitecontactCancel,
    },
    saga: requestAddSinglesitecontactRe,
  });
}

// {{url}}/contacts/add/:sudo_site_id
function* requestAddSinglesitecontactRe(action) {
  const { sudo_site_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for adding a contact"
    );

  try {
    const url = `/contacts/add/${sudo_site_id}`;

    const result = yield call(conxtdOut.post, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// UPDATE SITE CONTACTS/KEYHOLDERS
export function* watchSingleSiteUpdateContact() {
  // Reload contacts on successful update
  yield takeLeading("REQUEST_UPDATE_SINGLESITECONTACT_SUCCESS", function*(action) {
    yield put(
      loadSingleSiteContactsStart({
        sudo_site_id: action.startAction.sudo_site_id
      })
    );
  });

  yield actionWatcher({
    actions: {
      start: requestUpdateSinglesitecontactStart,
      failed: requestUpdateSinglesitecontactFailed,
      success: requestUpdateSinglesitecontactSuccess,
      cancel: requestUpdateSinglesitecontactCancel,
    },
    saga: requestUpdateSinglesitecontactRe,
  });
}

// {{url}}/contacts/edit/:contact_id
function* requestUpdateSinglesitecontactRe(action) {
  const { contact_id } = action;

  if (!contact_id) 
    throw new Error(
      "contact_id is required for updating a contact"
    );

  try {
    const url = `/contacts/edit/${contact_id}`;

    const result = yield call(conxtdOut.post, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// REMOVE SITE CONTACTS/KEYHOLDERS
export function* watchSingleSiteRemoveContact() {
  // Reload contacts on successful update
  yield takeLeading("REQUEST_REMOVE_SINGLESITECONTACT_SUCCESS", function*(action) {
    yield put(
      loadSingleSiteContactsStart({
        sudo_site_id: action.startAction.sudo_site_id
      })
    );
  });

  yield actionWatcher({
    actions: {
      start: requestRemoveSinglesitecontactStart,
      failed: requestRemoveSinglesitecontactFailed,
      success: requestRemoveSinglesitecontactSuccess,
      cancel: requestRemoveSinglesitecontactCancel,
    },
    saga: requestRemoveSinglesitecontactRe,
  });
}

// {{url}}/contacts/delete/:contact_id
function* requestRemoveSinglesitecontactRe(action) {
  const { contact_id } = action;

  if (!contact_id) 
    throw new Error(
      "contact_id is required for removing a contact"
    );

  try {
    const url = `/contacts/delete/${contact_id}`;

    const result = yield call(conxtdOut.post, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// MOVE SITE CONTACTS/KEYHOLDERS UP/DOWN
export function* watchSingleSiteMoveContact() {
  // Reload contacts on successful update
  yield takeLeading("REQUEST_MOVE_SINGLESITECONTACT_SUCCESS", function*(action) {
    yield put(
      loadSingleSiteContactsStart({
        sudo_site_id: action.startAction.sudo_site_id
      })
    );
  });
  yield actionWatcher({
    actions: {
      start: requestMoveSinglesitecontactStart,
      failed: requestMoveSinglesitecontactFailed,
      success: requestMoveSinglesitecontactSuccess,
      cancel: requestMoveSinglesitecontactCancel,
    },
    saga: requestMoveSinglesitecontactRe,
  });
}

// {{url}}/contacts/move/:contact_id/:direction
function* requestMoveSinglesitecontactRe(action) {
  const { contact_id, direction } = action;

  if (!contact_id) 
    throw new Error(
      "contact_id and direction are required for moving a contact"
    );

  try {
    const url = `/contacts/move/${contact_id}/${direction}`;

    const result = yield call(conxtdOut.post, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// LOAD NOTIFICATION RULES
export function* watchLoadSingleSiteNotificationsRules() {
  yield actionWatcher({
    actions: {
      start: loadSingleSiteNotificationsRulesStart,
      failed: loadSingleSiteNotificationsRulesFailed,
      success: loadSingleSiteNotificationsRulesSuccess,
      cancel: loadSingleSiteNotificationsRulesCancel,
    },
    saga: loadSingleSiteNotificationsRulesRe,
  });
}

// {{url}}/single-sites/notification-rules/:sudo_site_id
function* loadSingleSiteNotificationsRulesRe(action) {
  const { sudo_site_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for loading single site notification rules"
    );

  try {
    const url = `/single-sites/notification-rules/${sudo_site_id}`;

    const result = yield call(conxtdOut.get, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// ADD NOTIFICATION RULE
export function* watchSingleSiteNotificationsAddRule() {
  yield actionWatcher({
    actions: {
      start: singleSiteNotificationsAddRuleStart,
      failed: singleSiteNotificationsAddRuleFailed,
      success: singleSiteNotificationsAddRuleSuccess,
      cancel: singleSiteNotificationsAddRuleCancel,
    },
    saga: singleSiteNotificationsAddRuleRe,
  });
}

// {{url}}/single-sites/notifications/add-rule/{{sudo_site_id}}
function* singleSiteNotificationsAddRuleRe(action) {
  const { sudo_site_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for adding single site notification rules"
    );

  try {
    const url = `/single-sites/notifications/add-rule/${sudo_site_id}`;

    const result = yield call(conxtdOut.post, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// REMOVE NOTIFICATION RULE
export function* watchSingleSiteNotificationsRemoveRule() {
  yield actionWatcher({
    actions: {
      start: singleSiteNotificationsRemoveRuleStart,
      failed: singleSiteNotificationsRemoveRuleFailed,
      success: singleSiteNotificationsRemoveRuleSuccess,
      cancel: singleSiteNotificationsRemoveRuleCancel,
    },
    saga: singleSiteNotificationsRemoveRuleRe,
  });
}

// {{url}}/single-sites/notifications/delete-rule/{{rule_id}}
function* singleSiteNotificationsRemoveRuleRe(action) {
  const  rule_id = action?.params?.id;

  if (!rule_id) 
    throw new Error(
      "rule id is required for removing single site notification rules"
    );

  try {
    const url = `/single-sites/notifications/delete-rule/${rule_id}`;

    const result = yield call(conxtdOut.delete, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// LOAD NOTIFICATION HISTORY
export function* watchLoadSingleSiteNotificationHistory() {
  yield actionWatcher({
    actions: {
      start: loadSingleSiteNotificationHistoryStart,
      failed: loadSingleSiteNotificationHistoryFailed,
      success: loadSingleSiteNotificationHistorySuccess,
      cancel: loadSingleSiteNotificationHistoryCancel,
    },
    saga: loadSingleSiteNotificationHistoryRe,
  });
}

// {{url}}/single-sites/notification-history/:sudo_site_id/:mct_alarm_log_id
function* loadSingleSiteNotificationHistoryRe(action) {
  const { sudo_site_id, mct_alarm_log_id } = action;

  if (!sudo_site_id || !mct_alarm_log_id) 
    throw new Error(
      "sudo_site_id and mct_alarm_log_id are required for loading single site notification history"
    );

  try {
    const url = `/single-sites/notification-history/${sudo_site_id}/${mct_alarm_log_id}`;

    const result = yield call(conxtdOut.get, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// LOAD SCHEDULES
export function* watchLoadSiteSchedules() {
  yield actionWatcher({
    actions: {
      start: loadSiteSchedulesStart,
      failed: loadSiteSchedulesFailed,
      success: loadSiteSchedulesSuccess,
      cancel: loadSiteSchedulesCancel,
    },
    saga: loadSiteSchedulesRe,
  });
}

// {{url}}/analyticx/scheduler-rules/open-close/:sudo_site_id
function* loadSiteSchedulesRe(action) {
  const { sudo_site_id, enterprise_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for loading site schedules"
    );

  try {
    const url = `/analyticx/scheduler-rules/open-close/${sudo_site_id}${enterprise_id ? "/" + enterprise_id : ""}`;

    const result = yield call(conxtdOut.get, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// LOAD USERS
export function* watchLoadSingleSiteUsers() {
  yield actionWatcher({
    actions: {
      start: loadSingleSiteUsersStart,
      failed: loadSingleSiteUsersFailed,
      success: loadSingleSiteUsersSuccess,
      cancel: loadSingleSiteUsersCancel,
    },
    saga: loadSingleSiteUsersRe,
  });
}

// {{url}}/single-sites-admin/users/:sudo_site_id/(optional:type/optional:typeId)
function* loadSingleSiteUsersRe(action) {
  const { originType, originId, sudo_site_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for loading single site users"
    );

  try {
    const url = `/single-sites-admin/users/${sudo_site_id}${originType ? "/"+originType+"/"+originId : ""}`;

    const result = yield call(conxtdOut.get, url, action.params);

    return result;

  } catch (e) {
    // throw new Error(e);
    console.error(e);
  }
}

// GRANT USER ACCESS
export function* watchSingleSiteUserGrantAccess() {
  yield actionWatcher({
    actions: {
      start: singleSiteUserGrantAccessStart,
      failed: singleSiteUserGrantAccessFailed,
      success: singleSiteUserGrantAccessSuccess,
      cancel: singleSiteUserGrantAccessCancel,
    },
    saga: singleSiteUserGrantAccessRe,
  });
}

// {{url}}/single-sites/grant-access/:sudo_site_id/(optional:invite_type/optional:invite_type_id)
function* singleSiteUserGrantAccessRe(action) {
  const { sudo_site_id, invite_type, invite_type_id } = action;

  if (!sudo_site_id) 
    throw new Error(
      "sudo_site_id is required for granting access to a user"
    );

  try {
    const url = `/single-sites/grant-access/${sudo_site_id}${invite_type ? "/"+invite_type+"/"+invite_type_id : ""}`;

    const result = yield call(conxtdOut.post, url, action.params);

    return result;

  } catch (error) {
    yield put(
      singleSiteUserGrantAccessFailed({
        error: {
          message: error.message,
          status: error.response && error.response.status,
          statusText: error.response && error.response.statusText
        },
        ...action
      })
    );
  }
}

// REMOVE USER
export function* watchSingleSiteUserRemove() {
  yield actionWatcher({
    actions: {
      start: singleSiteUserRemoveStart,
      failed: singleSiteUserRemoveFailed,
      success: singleSiteUserRemoveSuccess,
      cancel: singleSiteUserRemoveCancel,
    },
    saga: singleSiteUserRemoveRe,
  });
}

// {{url}}/single-sites-admin/remove/:sudo_site_id/:user_id
function* singleSiteUserRemoveRe(action) {
  const { sudo_site_id, user_id } = action;

  if (!sudo_site_id || !user_id) 
    throw new Error(
      "sudo_site_id and user_id are required for removing a user"
    );

  try {
    const url = `/single-sites-admin/remove/${sudo_site_id}/${user_id}`;

    const result = yield call(conxtdOut.post, url, action.params);

    return result;

  } catch (error) {
    yield put(
      singleSiteUserRemoveFailed({
        error: {
          message: error.message,
          status: error.response && error.response.status,
          statusText: error.response && error.response.statusText
        },
        ...action
      })
    );
  }
}